import { useTranslation } from "react-i18next";
import { Modal, Box, Typography, List, Grid, IconButton } from "@mui/material";
import { Api } from "queries/types";
import LegendItem from "components/LegendItem";
import GridCell from "components/BaseCell";
import CloseIcon from "@mui/icons-material/Close";

const modalSx = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "80vw", sm: "70vw" },
  maxHeight: "90vh",
  overflow: "auto",
  boxSizing: "border-box",
  bgcolor: "background.paper",
  border: "1px solid #000",
  boxShadow: 24,
  p: 2,
};

interface LegendModalProps {
  furnitures: Api.ShopFurniture[];
  families: Api.Family[];
  onClose: () => void;
}

const LegendModal = ({ furnitures, families, onClose }: LegendModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal open onClose={onClose}>
      <Box sx={modalSx}>
        <IconButton
          aria-label={t("a11y.closeModal")}
          onClick={onClose}
          sx={{ position: "absolute", top: "10px", right: "10px" }}
        >
          <CloseIcon />
        </IconButton>
        <Grid container>
          <Grid item sm={4} xs={12}>
            <Typography variant="h6">{t("furnitures")}</Typography>
            <List>
              {furnitures.map((furniture) => (
                <LegendItem text={furniture.name}>
                  <GridCell color={furniture.color} />
                </LegendItem>
              ))}
            </List>
          </Grid>
          <Grid item sm={4} xs={12}>
            <Typography variant="h6">{t("families")}</Typography>
            <List>
              {families.map((family) => (
                <LegendItem text={family.name}>
                  <GridCell color={family.color} />
                </LegendItem>
              ))}
            </List>
          </Grid>
          <Grid item sm={4} xs={12}>
            <Typography variant="h6">{t("furnitureSpecificities")}</Typography>
            <List>
              <LegendItem text={t("shop.inventory.legend.notRecordable")}>
                <GridCell color="#cecece" blocked style={{ border: "1px solid grey" }} />
              </LegendItem>
              <LegendItem text={t("shop.inventory.legend.isHighlight")}>
                <GridCell color="#ecffd4" isHighlight style={{ border: "1px solid grey" }} />
              </LegendItem>
            </List>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
};

export default LegendModal;
